import { LoadFeatures } from '../constants/LoadOffer'

export function isLoadTaken(load) {
  return !load || !load?.active_offer
}

export function isLoadOfferAvailable(load, isLoadTakenFlag) {
  return load && !isLoadTakenFlag
}

export function hasFeature(stops = [], feature) {
  return stops.some(stop => stop.tags?.includes(feature))
}

export function hasFastFacility(stops = []) {
  return hasFeature(stops, LoadFeatures.FastFacility)
}

export function hasTopRatedFacility(stops = []) {
  return hasFeature(stops, LoadFeatures.TopRatedFacility)
}

export function hasEarlyAppointment(stops = []) {
  return hasFeature(stops, LoadFeatures.EarlyAppointment)
}

export function isPalletized(load) {
  return load?.tags?.includes(LoadFeatures.Palletized)
}

export function getLoadFeatures(offer = {}) {
  const loadFeatures = offer.load?.tags ?? []
  const stopFeatures =
    offer.load?.stops?.reduce((acc, next) => {
      if (!next?.tags) return acc
      return [...acc, ...next.tags]
    }, []) ?? []

  const allFeatures = [...loadFeatures, ...stopFeatures]

  const uniqueFeatures = new Set(allFeatures)

  return [...uniqueFeatures]
}

export default { isLoadTaken }
